import env from './../environments/index';

const getCurrentThemeURL = theme => {
  return env.assetsEndpoint + 'themes/' + theme + '/';
};

const getCurrentThemeStyleURL = theme => {
  return getCurrentThemeURL(theme) + 'md-sidebar/src/styles/styles.css';
};

export { getCurrentThemeURL, getCurrentThemeStyleURL };
